import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createStore, applyMiddleware, compose } from 'redux';
import root_reducer from './store/reducers/root-reducer';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './config/fb-config';

import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { PersistGate } from 'redux-persist/integration/react';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['auth']
}

const persistedReducer = persistReducer(persistConfig, root_reducer)


const store = createStore(persistedReducer,
    composeEnhancers(
        applyMiddleware(thunk)
    )
);

const persistor = persistStore(store);


onAuthStateChanged(auth, (user) => {
    store.dispatch({
        type: 'AUTH_STATE_CHANGED',
        payload: user ? { uid: user.uid, email: user.email } : null
    });
});

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <HelmetProvider>
                <App />
            </HelmetProvider>
        </PersistGate>
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
